let pill_filters = {
          All: {name: 'All', display: 'All', is_active: 1, is_visible: true, count: 0},
}

module.exports = pill_filters